module.exports = __webpack_public_path__ + "img/call.bb52b2b1.svg";